import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import ItemWrapper from "./partial/item-wrapper";
import styles from "./styles/icon-menu-item.css.js";

const IconMenuItem = ({ url, disabled, text, children, classes, externalUrl, ...props }) => (
  <ItemWrapper disabled={disabled} className={classes.wrapper} url={url} externalUrl={externalUrl} {...props}>
    <div className={classes.largeIcon}>{children}</div>
    {text && <div>{text}</div>}
  </ItemWrapper>
);

IconMenuItem.propTypes = {
  /**
   * Indica si es una url externa a tiivii
   */
  externalUrl: PropTypes.bool,
  /**
   * Indica si el elemento del menú está deshabilitado
   */
  disabled: PropTypes.bool,
  /**
   * Texto del elemento de menú
   */
  text: PropTypes.string,
  /**
   * Url del elemento de menú
   */
  url: PropTypes.string.isRequired,
};

export default withStyles(styles)(IconMenuItem);
